import { render } from "./SitemapPage.vue?vue&type=template&id=5803128b&scoped=true"
import script from "./SitemapPage.vue?vue&type=script&lang=js"
export * from "./SitemapPage.vue?vue&type=script&lang=js"

import "./SitemapPage.vue?vue&type=style&index=0&id=5803128b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5803128b"]])

export default __exports__